import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import LogoutIcon from '@/assets/icons/logout.svg';
import { PlaneSendIcon } from '@/components/icons/plane-send';
import { Button } from '@/components/ui/button';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { ChannelsPopover } from './channels-popover';
import { OpeningsPopover } from './openings-popover';
import { Stepper } from './stepper';
import { useValidatedStepper } from './use-validated-stepper';

export function Header() {
  const navigate = useNavigate();
  const { currentStep, clearJobPostingStorage, isSubmitting } =
    useJobPostingContext();
  const { handleNext, handleStepClick, isLoading } = useValidatedStepper();

  const handleQuit = () => {
    clearJobPostingStorage();

    navigate(-1);
  };

  return (
    <div className="relative flex items-center justify-between bg-white p-2">
      <div className="flex items-center gap-4">
        <Button variant="secondary" type="button" onClick={handleQuit}>
          <img src={LogoutIcon} alt="" />
          <FormattedMessage
            defaultMessage="Quit"
            description="Button to quit the campaign creation"
          />
        </Button>
        <ChannelsPopover />
        <div className="bg-fx-neutral-200 h-9 w-px" />
        <OpeningsPopover />
      </div>

      <div className="absolute left-1/2 -translate-x-1/2">
        <Stepper handleStepClick={handleStepClick} />
      </div>

      <div className="flex">
        {/* Next button for Job details, Pool and Spend steps */}
        {currentStep !== 4 && (
          <Button
            type="button"
            onClick={() => void handleNext()}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="animate-spin" />}
            <FormattedMessage
              defaultMessage="Next"
              description="Button to navigate to the next page"
            />
          </Button>
        )}

        {/* Post button for post step */}
        {currentStep === 4 && (
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <Loader2 className="animate-spin" />
            ) : (
              <PlaneSendIcon className="text-white" />
            )}
            <FormattedMessage
              defaultMessage="Post Job"
              description="Button to post the campaign"
            />
          </Button>
        )}
      </div>
    </div>
  );
}
